import { NonSubmitableForm } from 'features/common'
import { ProviderType } from 'features/connections'
import { DataExplorerTable } from 'features/data-explorer/types'
import { GeomType } from 'features/maps/types'
import { AggregationOutputFormats } from 'features/data-explorer/types'

export const GeocodeableProviders = [
  ProviderType.BIGQUERY,
  ProviderType.SNOWFLAKE,
  ProviderType.REDSHIFT,
  ProviderType.POSTGRES
]

export const GeomTypeSupportsCreateTilesetWithAggregation = [GeomType.Points]

export const ProviderSupportsAggregationOutputFormats = {
  [ProviderType.BIGQUERY]: [
    AggregationOutputFormats.Geometries,
    AggregationOutputFormats.H3,
    AggregationOutputFormats.Quadbin
  ],
  [ProviderType.SNOWFLAKE]: [
    AggregationOutputFormats.Geometries,
    AggregationOutputFormats.H3,
    AggregationOutputFormats.Quadbin
  ],
  [ProviderType.REDSHIFT]: [AggregationOutputFormats.Geometries, AggregationOutputFormats.Quadbin],
  [ProviderType.POSTGRES]: [AggregationOutputFormats.Geometries, AggregationOutputFormats.Quadbin]
}

export interface GeocodeDataForm {
  geocodeInput: string
  geocodeBy: string
  geomColumn: string
  country: string
  address: string
  longitude: string
  latitude: string
  connection: string
  id: string
}
export interface GeocodeFormStepsProps {
  form: NonSubmitableForm
  table: DataExplorerTable
  data: GeocodeDataForm
  connection: string
  provider: ProviderType
  spatialExtension: boolean
  step?: number
  onCancel: () => void
  onNext: () => void
}

export enum GeocodeBy {
  Address = 'address',
  LatLon = 'latlon'
}
